import { useCallback } from "react";
import { Check, Download } from "lucide-react";
import styles from "./styles.module.scss";
import { useDropzone } from "react-dropzone";
import cn from "classnames";

interface FileDropAreaProps {
  onAttachFile: (files: File[]) => void;
  value: File[];
  className?: string;
}

const FileDropArea = (props: FileDropAreaProps) => {
  const { onAttachFile } = props;
  const onDrop = useCallback((acceptedFiles) => {
    onAttachFile(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const isThereAnythingSelected = props.value.length !== 0;
  return (
    <div
      title="Select document to upload"
      className={cn(
        { [styles.uploadArea]: true, [styles.uploadArea_selectedFiles]: isThereAnythingSelected },
        props.className
      )}
    >
      <div className={styles.uploadAreaInner} {...getRootProps()}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : (
          <>
            {!isThereAnythingSelected ? (
              <>
                <Download className="mb-4 size-[60px] text-wfp-blue" strokeWidth={1.5} />
                <strong className="mb-2 text-sm">
                  Drop files to upload or <span className="cursor-pointer text-primary-600 underline">browse</span>
                </strong>
                <div className="text-xs [color:var(--text-02)]">pdf, xls, doc, maximum up to 500MB</div>
              </>
            ) : (
              <>
                <Check className="mb-4 size-[60px] text-wfp-blue" strokeWidth={2} />
                <strong className="mb-2 text-sm">Selected {props.value[0].name}</strong>
                <div className="text-xs [color:var(--text-02)]">Click to select another document</div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default FileDropArea;
